



























































































import { Component, Vue } from "vue-property-decorator";
import PayCardForm from "@/components/payment/PayCardForm.vue";
import MoneyField2 from "@/components/MoneyField2.vue";
import { FileNameData, TransactionItem } from "@/domain/types/transactions_query";
import { calcTransactionStatsV2, StatisticsResult } from "@/domain/transaction_stats2";
import * as excel from "@/util/excel";
import * as backend from "@/domain/backend";

@Component({ components: { PayCardForm, MoneyField2 } })
export default class TxnStadisticsDialog extends Vue {
  txnInfoTab = 0;
  dialog = false;
  tableData: null | TransactionItem = null;
  data: null | TransactionItem[] = null;
  bankBranch = "bank";
  amountQuantity = "amount";
  searchData: null | FileNameData = null;

  get lang() {
    return this.$store.state.lang.data;
  }

  snackShow(message: string, color: string) {
    this.$emit("message", { message, color });
  }

  close() {
    this.dialog = false;
  }

  get filteredStats(): StatisticsResult {
    return calcTransactionStatsV2(this.data as TransactionItem[], { forBank: this.bankBranch === "bank" });
  }

  formatNumber(vaule: number) {
    const numberFormatter = Intl.NumberFormat("de-DE");
    const formatted = numberFormatter.format(vaule);
    return formatted;
  }

  async cmdExportExcel() {
    // const filename = "Estadisticas";
    const filename = backend.getFileName(
      "statistics",
      this.searchData?.companyName || "",
      this.searchData?.branchName || "",
      this.searchData?.from || "",
      this.searchData?.to || ""
    );
    const headers = [];

    headers.push({
      common: {
        header: this.bankBranch === "bank" ? this.lang.bank.toUpperCase() : this.lang.branch.toUpperCase(),
        key: "name",
        width: 30
      },
      other: {
        format: undefined
      }
    });
    this.filteredStats.headers.forEach((e) => {
      headers.push({
        common: {
          header: e,
          key: e,
          width: 15
        },
        other: {
          format: undefined
        }
      });
    });
    const data: (string | number)[][] = [];
    const items =
      this.amountQuantity === "amount"
        ? this.filteredStats.cardTypeSummary
        : this.filteredStats.cardTypeSummaryQuantity;
    for (const key in items) {
      const item = items[key];
      const row: (string | number)[] = [item.name];
      this.filteredStats.headers.forEach((h) => row.push(item.cardTypes[h]));
      data.push(row);
    }
    return excel.writeSpreadsheet(filename, "resumen", headers, data);
  }

  open(data: TransactionItem[], searchData: FileNameData) {
    this.data = data;
    this.searchData = searchData;
    this.dialog = true;
  }
}
